module.exports = __webpack_public_path__ + "img/Map_4__First_Canal_Welland_Canal_1837_NMC_21589.ffe53aed.jpg";